import moment from "moment";
import React from "react";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { formatWrittenDateTimeUtc } from "../../utilities";

interface Props {
  item: server.dto.DocumentChecklistItem
  reset: () => void
}

const ChecklistApprovedRowCard = (props: Props) => {
  const { item } = props;

  const checkedUtcMoment = moment.utc(item.checkedUtc);

  return <div className="lightgreen-bg">
    <div className="grow1">
      <div className="flex">
        <div className="margin-right">
          <UserAvatar user={item.checkedUser} />
        </div>

        <div className="grow1">
          <div><h3>{item.question}</h3></div>
          <div className="margin-top-small" title={formatWrittenDateTimeUtc(checkedUtcMoment)}>{RESX.Checklist.ApprovedBy} {item.checkedUser.fullName} {checkedUtcMoment.fromNow()}</div>
        </div>

        <div>
          <i className="icon-check green big" onClick={props.reset} />
        </div>
      </div>
    </div>
  </div>;
};

export default ChecklistApprovedRowCard;